import faIcon from './FaIcon.vue'
export default {
  install(Vue) {
    Vue.component('FaIcon', faIcon)
  }
}
